module.exports = __webpack_public_path__ + "static/media/help-icon.3a974bb5.svg";